import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';

import { FormControlComponent } from '../../abstracts/form-control.abstract';

@Component({
    selector: 'app-ng-multi-select',
    templateUrl: './ng-multi-select.component.html',
    styleUrls: ['./ng-multi-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: NgMultiSelectComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: NgMultiSelectComponent,
        },
    ],
})
export class NgMultiSelectComponent extends FormControlComponent implements OnInit, AfterViewInit, OnDestroy {
    /**
     * data: data array for select - options
     * Base data type: IQuestionChoice[]
     * */
    @Input() public data: any[];

    /**
     * bindLabel: value to be used as select - options label
     * Base value: 'label' -> IQuestionChoice.label
     * */
    @Input() public bindLabel = 'label';

    /**
     * bindValue: value to be returned as selected option value
     * Base value: 'value' -> IQuestionChoice.value
     * */
    @Input() public bindValue = 'value';

    @Input() public selectLabel: string;
    @Input() public placeholder: string;
    @Input() public closeOnSelect = false;
    @Input() public searchable = false;
    @Input() public multipleSelection = true;
    @Input() public defaultOpen = false;
    @Input() public readonly = false;
    @Input() public selectAllAvailable = false;
    @Input() public notFoundText = 'SHARED.NO-DATA';

    public control: FormControl;

    @ViewChild('select', { static: false }) public select: NgSelectComponent;

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.control = new FormControl({ value: [], disabled: this.readonly });
    }

    public ngAfterViewInit(): void {
        if (this.defaultOpen) {
            this.select.open();
        }
    }

    public ngOnDestroy(): void {
        this.select.ngOnDestroy();
        super.ngOnDestroy();
    }

    public selectAll(): void {
        this.control.patchValue(this.data.map((val: any) => val[this.bindValue]));
        this.onValueChange();
    }

    public writeValue(obj: any): void {
        this.value = obj;
        this.control.patchValue(obj);
    }

    public onValueChange(): void {
        if (this.disabled) {
            return;
        }

        this.value = this.control.value;
        this.onChange(this.value);
        if (!this.touched) {
            this.onTouched();
        }
    }

    public validate(): ValidationErrors | null {
        return this.control.invalid ? this.control.errors : null;
    }

    public setDisabledState(disabled: boolean): void {
        this.disabled = disabled;
        if (this.disabled) {
            this.control.disable();
        } else {
            this.control.enable();
        }
    }
}
